import React from "react";
import UserForm from './UserForm';

const EditUser = ({ onCloseDialog, employeeData }) => (
    <UserForm onCloseDialog={onCloseDialog} employeeData={employeeData} />
);

export default EditUser;
